export enum PanelViews {
  Search = 'search',
  PetProfile = 'petProfile',
  PetParentProfile = 'petParentProfile',
  AddClientPatientForm = 'addClientPatientForm',
  Invoicing = 'invoicing',
  Scheduler = 'scheduler',
  Menu = 'menu',
  Benefits = 'benefits',
  MassTextAlerts = 'massTextAlerts',
  LoyaltyRewards = 'loyaltyRewards',
  // Left Panel
  Appointments = 'Appointments',
  Board = 'Board',
  Conversations = 'Conversations',
  TeamChat = 'Team Chat',
  LoyaltyProgram = 'Loyalty Program',
  EmailCampaigns = 'Email Campaigns',
  Survey = 'Survey',
  Reporting = 'Reporting',
  Automations = 'Automations',
  MessageTemplates = 'Message Templates',
  Forms = 'Forms',
  Settings = 'Settings',
  None = 'None',
  Tasks = 'Tasks',
}
